import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DocumentEntry } from '../../interfaces';
import { RootState } from '../../store';

export interface RFXRequestDocumentStepState {
  isAddDocumentModalVisible: boolean;
  isRemoveDocumentModalVisible: boolean;
  isAddSupportDocumentModalVisible: boolean;
  selectedItems: DocumentEntry[];
  selectedSupportingDocuments: DocumentEntry[];
}

const initialState: RFXRequestDocumentStepState = {
  isAddDocumentModalVisible: false,
  isRemoveDocumentModalVisible: false,
  isAddSupportDocumentModalVisible: false,
  selectedItems: [],
  selectedSupportingDocuments: []
};

const rfxRequestDocumentStepSlice = createSlice({
  name: 'rfxRequestDocumentStep',
  initialState,
  reducers: {
    setIsAddDocumentModalVisible(state: RFXRequestDocumentStepState, action: PayloadAction<boolean>) {
      state.isAddDocumentModalVisible = action.payload;
    },
    setIsRemoveDocumentModalVisible(state: RFXRequestDocumentStepState, action: PayloadAction<boolean>) {
      state.isRemoveDocumentModalVisible = action.payload;
    },
    setIsAddSupportDocumentModalVisible(state: RFXRequestDocumentStepState, action: PayloadAction<boolean>) {
      state.isAddSupportDocumentModalVisible = action.payload;
    },
    setSelectedItems(state: RFXRequestDocumentStepState, action: PayloadAction<DocumentEntry[]>) {
      state.selectedItems = action.payload;
    },
    setSelectedSupportingDocuments(state: RFXRequestDocumentStepState, action: PayloadAction<DocumentEntry[]>) {
      state.selectedSupportingDocuments = action.payload;
    },
    resetState(state: RFXRequestDocumentStepState, action) {
      state = initialState;
    }
  }
});

export const {
  setIsAddDocumentModalVisible,
  setIsRemoveDocumentModalVisible,
  setIsAddSupportDocumentModalVisible,
  setSelectedItems,
  setSelectedSupportingDocuments,
  resetState
} = rfxRequestDocumentStepSlice.actions;

export const selectIsAddDocumentModalVisible = (state: RootState): boolean => {
  return state.rfxRequestDocumentStep.isAddDocumentModalVisible;
};

export const selectIsRemoveDocumentModalVisible = (state: RootState): boolean => {
  return state.rfxRequestDocumentStep.isRemoveDocumentModalVisible;
};

export const selectIsAddSupportDocumentModalVisible = (state: RootState): boolean => {
  return state.rfxRequestDocumentStep.isAddSupportDocumentModalVisible;
};

export const selectSelectedItems = (state: RootState): DocumentEntry[] => {
  return state.rfxRequestDocumentStep.selectedItems;
};

export const selectSelectedSupportingDocuments = (state: RootState): DocumentEntry[] => {
  return state.rfxRequestDocumentStep.selectedSupportingDocuments;
};

export default rfxRequestDocumentStepSlice.reducer;
